import { useEffect, useState } from "react";
import { doc, onSnapshot } from "./firestore";
import { db } from "../firebase";
import { useClinic } from "../context/ClinicContext";
export function usePatientRecord(initial) {
  const { clinicId, currentUser } = useClinic();
  const [record, setRecord] = useState(initial),
    [error, setError] = useState("");
  const patientId = initial?.id;
  useEffect(() => {
    setRecord(initial);
    setError("");
    if (!clinicId || !patientId) return;
    return onSnapshot(
      doc(db, "clinics", clinicId, "pacientes", patientId),
      (snapshot) => {
        setRecord(
          snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null,
        );
      },
      (caught) => {
        setRecord(null);
        setError(caught.message || "No se pudo abrir el expediente.");
      },
    );
    // Permission changes require a new server projection, even when the patient is unchanged.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId, patientId, currentUser]);
  return { patient: record || { id: patientId }, error };
}
